import React from "react";
import PropTypes from "prop-types";
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	FormGroup,
	Label,
	Input,
} from "reactstrap";
import { X } from "@phosphor-icons/react";

const AddCargoModal = ({
	show,
	onCloseClick,
	onAddClick,
	cargoName,
	onNameChange,
}) => (
	<Modal isOpen={show} toggle={onCloseClick}>
		<ModalHeader toggle={onCloseClick}>Adicionar Novo Cargo</ModalHeader>
		<ModalBody>
			<FormGroup>
				<Label for="cargoName">Nome do Cargo</Label>
				<Input
					id="cargoName"
					type="text"
					value={cargoName}
					onChange={onNameChange}
					placeholder="Digite o nome do cargo"
				/>
			</FormGroup>
		</ModalBody>
		<ModalFooter>
			<Button
				style={{
					background: "none",
					cursor: "pointer",
					color: "black",
					marginLeft: 10,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					gap: 2,
				}}
				onClick={onCloseClick}
			>
				<X size={16} /> Cancelar
			</Button>
			<Button
				style={{
					background: "none",
					cursor: "pointer",
					color: "black",
					marginLeft: 10,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					gap: 2,
				}}
				onClick={onAddClick}
			>
				Adicionar
			</Button>
		</ModalFooter>
	</Modal>
);

AddCargoModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onCloseClick: PropTypes.func.isRequired,
	onAddClick: PropTypes.func.isRequired,
	cargoName: PropTypes.string.isRequired,
	onNameChange: PropTypes.func.isRequired,
};

export default AddCargoModal;
